import { Autocomplete, TextField, CircularProgress } from '@mui/material';

const DropdownFilter = ({ filterOption, filterMenu, keyParam, onFieldChange, placeHolder, disabled }) => {
    const config = filterMenu[keyParam];
    const { options, valueKey, labelKey, multiple, renderOption, loading } = config;
    const getMultiValue = () => {
        if (!options?.length || !filterOption[keyParam]) return [];
        const selectedValues = filterOption[keyParam].toString().split(',');
        return options.filter((item) => selectedValues.includes(item[valueKey].toString()));
    };

    const getSingleValue = () => {
        if (!options?.length || !filterOption[keyParam]) return null;
        return options.find((item) => item[valueKey] === filterOption[keyParam]) || null;
    };

    return (
        <Autocomplete
            options={options}
            getOptionLabel={(option) => option[labelKey]}
            getOptionKey={(option) => option[valueKey]}
            id={keyParam}
            multiple={!!multiple}
            disabled={!!disabled}
            loading={!!loading}
            value={multiple ? getMultiValue() : getSingleValue()}
            onChange={(_, value) => {
                if (multiple) {
                    onFieldChange(keyParam, value.map((item) => item[valueKey]).join(',').toString());
                } else {
                    onFieldChange(keyParam, value ? value[valueKey] : null);
                }
            }}
            isOptionEqualToValue={(option, value) => option[valueKey] === value[valueKey]}
            {...(renderOption && { renderOption })}
            size='small'
            sx={{ mt: 2, '& .MuiOutlinedInput-root': { borderRadius: '5px' } }}
            renderInput={(params) => (
                <TextField
                    slotProps={{ inputLabel: { shrink: true } }}
                    {...params}
                    label={config.title}
                    fullWidth
                    placeholder={placeHolder}
                    variant='outlined'
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress color="primary" size={16} sx={{ mr: 1 }} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
        />
    );
};

export default DropdownFilter;
